import * as React from 'react'
import { useGastroProductProvider } from '@modules/products/hooks/use-gastro-product-provider'
import { GastroProductKind } from '@models/products'
import { useAuthenticatedUser } from '@components/hooks/use-authenticated-user'
import { useModal } from '@components/modals/use-modal'
import { useUpsellBookingDetailsRefresh } from '@modules/upselling/upsell-booking-details/use-upsellbooking-details-refresh'
import { ClientUser } from '@models/clients'
import { ButtonWithIcon } from '@components/button-with-icon'
import { UpsellBookingsDetailsProductsSaleBaseRow } from '@modules/upselling/upsell-booking-details/products/sale-card/upsell-bookings-details-products-sale-base-row'

interface Props {
  kind: GastroProductKind
  client: ClientUser
  name: string
}

export const UpsellBookingsGastroProductSaleRow = ({ kind, client, name }: Props): JSX.Element | null => {
  const user = useAuthenticatedUser()

  const { refresh } = useUpsellBookingDetailsRefresh()

  const [showGastroGenericProductCreate] = useModal(
    'GastroGenericProductDialog',
    { kind, gastroCouponClient: client },
    { onClose: refresh, persist: true },
  )

  const gastroProductProvider = useGastroProductProvider(kind)

  if (!user.hasPerm(gastroProductProvider?.crud_permissions.create)) return null

  return (
    <UpsellBookingsDetailsProductsSaleBaseRow name={name}>
      <ButtonWithIcon
        icon="uil-plus font-16 lh-1"
        text="Sprzedaj"
        color="btn btn-green btn-tall"
        handleClick={showGastroGenericProductCreate}
      />
    </UpsellBookingsDetailsProductsSaleBaseRow>
  )
}
